import { Dropdown, Flex, Tag, Typography } from "antd"

import Icon from "../../../../../Icon"
import { statusColorMap } from "../../utils/constants"

import "./styles.less"

const { Text } = Typography

const StatusTag = ({ status, withDropdown, options, onChange }) => {
  return withDropdown ? (
    <Dropdown
      destroyPopupOnHide={true}
      overlayClassName="custom-dropdown"
      menu={{
        items: options?.map((el) => {
          if (el !== status)
            return {
              key: el,
              label: (
                <Flex gap={8} align="center">
                  <Text>{el}</Text>
                </Flex>
              )
            }
        }),
        onClick: ({ key, domEvent }) => {
          domEvent.stopPropagation()
          onChange(key)
        }
      }}
    >
      <Tag
        key={status}
        className={`withdrawal-status simple newTagStyle ${statusColorMap[status]}`}
        style={{ margin: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <Flex gap={8} align="center">
          <Text>{status}</Text>
          <Icon type="chevron_down_small" style={{ marginLeft: -4, marginRight: -4 }} />
        </Flex>
      </Tag>
    </Dropdown>
  ) : (
    <Tag
      key={status}
      className={`withdrawal-status simple newTagStyle ${statusColorMap[status]}`}
      style={{ margin: 0 }}
    >
      <Flex gap={8} align="center">
        <Text>{status}</Text>
      </Flex>
    </Tag>
  )
}

export default StatusTag
